/* eslint-disable import/prefer-default-export */

import omit from 'lodash/omit';

import { bookingEntryTypes } from '../constants';

function getFieldsToRemove() {
  return [
    'id',
    'opportunity',
    'invoice',
    'created',
    'lastModified',
    'createdBy',
    'lastModifiedBy',
  ];
}

export function transformForPatch(model) {
  const entry = omit(model, getFieldsToRemove());
  entry.entryType = entry.entryType || bookingEntryTypes.MANUAL.label;
  return entry;
}
